import { RichTextHelper } from 'src/app/core/helpers/rich-text.helper';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NullSafe } from 'src/app/core/types/null-safe.type';

@Pipe({
  name: 'linkifySolicitacao',
})
export class LinkifySolicitacaoPipe implements PipeTransform {
  private readonly PROTOCOL_REGEX = /\b\d{2}\.\d{5}\.\d{4}\b/g;

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: NullSafe<string>): SafeHtml {
    if (!value) return value;

    // Parse como DOM para não tocar em atributos nem links já existentes
    const template = document.createElement('template');
    template.innerHTML = RichTextHelper.sanitizeHtml(value);

    this.processNode(template.content);

    return this.sanitizer.bypassSecurityTrustHtml(RichTextHelper.sanitizeHtml(template.innerHTML));
  }

  private processNode(node: Node): void {
    node.childNodes.forEach(child => {
      // Pula qualquer <a> e seus descendentes integralmente
      if (child.nodeType === Node.ELEMENT_NODE && (child as Element).tagName === 'A') return;

      if (child.nodeType === Node.TEXT_NODE) {
        const text = child.textContent ?? '';
        if (!this.PROTOCOL_REGEX.test(text)) return;

        // Reconstrói o TextNode como fragmento HTML com links
        this.PROTOCOL_REGEX.lastIndex = 0;
        const fragment = document.createDocumentFragment();
        let lastIndex = 0;
        let match: RegExpExecArray | null;

        while ((match = this.PROTOCOL_REGEX.exec(text)) !== null) {
          if (match.index > lastIndex) {
            fragment.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
          }

          const middleMatch = match[0].match(/\d{2}\.(\d{5})\.\d{4}/);
          const numero = middleMatch ? middleMatch[1].replace(/^0+/, '') : match[0];
          const anchor = document.createElement('a');
          anchor.href = `/unidade/solicitacao/detalhes?codsolicitacao=${numero}`;
          anchor.textContent = match[0];
          fragment.appendChild(anchor);

          lastIndex = this.PROTOCOL_REGEX.lastIndex;
        }

        if (lastIndex < text.length) {
          fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
        }

        child.parentNode?.replaceChild(fragment, child);
      } else {
        this.processNode(child);
      }
    });
  }
}
